export const filmStripView = 'filmStripView' as const;
export const listView = 'listView' as const;
export const gridView = 'gridView' as const;
export type AttachmentView = typeof filmStripView | typeof listView | typeof gridView;
